<template>
	<div>
		<div :title="$txt.filter" v-if="selected_recording_type == 7 && this.selected_recording">
			<LabeledCheckbox
				v-if="include_table"
				:label="$txt.on_voltage"
				v-model="includeVoltageApplied"
			/>
			<LabeledCheckbox
				:label="$txt.ir_value"
				v-model="includeInstantOff"
			/>
			<LabeledCheckbox
				:label="$txt.h4_value"
				v-model="include4HourValue"
			/>
			<LabeledCheckbox
				:label="$txt.h10_value"
				v-model="include10HourValue"
			/>
			<LabeledCheckbox
				:label="$txt.max_value"
				v-model="includeMaxValue"
			/>
			<LabeledCheckbox
				:label="$txt.last_value"
				v-model="includeLastValue"
			/>
			<LabeledCheckbox
				:label="$txt.h24_value"
				v-model="include24Hourvalue"
			/>
			<LabeledCheckbox
				v-if="include_table" 
				:label="$txt.residual_voltage"
				v-model="includeResidualvoltage"
			/>
			<br />
		</div>
		<div v-if="tableRows.length && selected_recording_type == 7">
			<br />
			<input type="checkbox" v-model="include_table"/>
			<span class="checkbox-label">
				{{ ' Include table' }}
			</span>
		</div>
		<div :title="'Table'" v-if="tableRows.length && selected_recording_type == 7 && include_table">
			<DecayResultTable
				ref="decayTbl"
				:sltd_zone="selected_zone"
				:tableHeaders="tableHeaders"
				:tableRows="tableRows"
				:automaticReport = "automaticReport"
				@img-export="onDecayTableImg"
			/>
		</div>
		<div v-if="chartGroups.length && selected_recording_type == 7 && this.selected_recording">
			<br />
			<input type="checkbox" v-model="include_bar_chart"/>
			<span class="checkbox-label">
				{{ ' Include bar chart' }}
			</span>
		</div>
		<div :title="'Bar chart'" v-if="chartGroups.length && selected_recording_type == 7 && include_bar_chart && this.selected_recording">
			<BarChart 
				ref="bar"
				:sltd_zone="selected_zone" 
				:headers="legendHeaders" 
				:groups="chartGroups" 
				:height="280" 
				:automaticReport = "automaticReport"
				@img-export="onBarChartImg"
			/>
		</div>
	</div>
</template>

<script>
import BarChart from "@/components/global/indicators/BarChart.vue";
import DecayResultTable from "@/components/global/indicators/DecayResultTable.vue";
import { BarChartData } from "@/api/barchartdata.js";
const Camur = require("@/utils/camurutils").default;

export default {
  name: "BarCharts",

	components: { BarChart, DecayResultTable },

	props: {
		selected_zone: { type: Object, required: true },

		selected_recording_type: { type: Number, required: true },
		selected_recording: { type: Object, default: null },
		selected_recordings: { type: Array, default: null },
		selected_interval: { type: Object, default: null },

		include_table_prop: { type: Boolean, default: true },
		include_bar_chart_prop: { type: Boolean, default: true },

		includeInstantOff_prop: { type: Boolean, default: true },
		includeVoltageApplied_prop: { type: Boolean, default: true },
		include4HourValue_prop: { type: Boolean, default: true },
		include10HourValue_prop: { type: Boolean, default: true },
		include24Hourvalue_prop: { type: Boolean, default: true },
		includeMaxValue_prop: { type: Boolean, default: true },
		includeLastValue_prop: { type: Boolean, default: false },
		includeResidualvoltage_prop: { type: Boolean, default: true},

		series_with_color: { type: Array, default: null },
		graph_state: { type: Number, default: 0 },
		//Automatic report props:
		automaticReport: { type: Boolean, default: false }
	},
	data() {
		return {
			include_table: this.include_table_prop,
			include_bar_chart: this.include_bar_chart_prop,
			//Decay results
			bar_chart_data_api: null,
			bar_chart_data: {},
			includeInstantOff: this.includeInstantOff_prop,
			includeVoltageApplied: this.includeVoltageApplied_prop,
			include4HourValue: this.include4HourValue_prop,
			include10HourValue: this.include10HourValue_prop,
			include24Hourvalue: this.include24Hourvalue_prop,
			includeMaxValue: this.includeMaxValue_prop,
			includeLastValue: this.includeLastValue_prop,
			includeResidualvoltage: this.includeResidualvoltage_prop,
		};
	},

	created() {
    this.bar_chart_data_api = new BarChartData(this.$app, this.$appm.net);
		this.fetch_decay_results_data();
  },

	watch: {
		selected_recording() { if (this.selected_recording) this.fetch_decay_results_data(); },
		selected_recordings: {
			handler(val) {
				if (!this.selected_recording &&
						Array.isArray(val) && val.length &&
						this.selected_recording_type === 7) {
					this.fetch_decay_results_data();
				} else if (!Array.isArray(val) || !val.length) {
					this.bar_chart_data = {};
				}
			},
			deep: false,
			flush: 'post'
		},
		selected_interval() { if (this.selected_interval) this.fetch_decay_results_data(); },
		graph_state() {
			if (this.selected_recording || this.selected_recording_type !== 7) return;
			if (!this.series_with_color?.length) return;
			this.fetch_decay_results_data();
		},
		selected_zone: { handler() { this.bar_chart_data = {}; this.fetch_decay_results_data(); }, deep: false },
		include_table()     { this.$nextTick(() => this.onIncludeDecayResultsTable()); },
    include_bar_chart() { this.$nextTick(() => this.onIncludeBarChart()); },
		includeInstantOff(val, old) { if (val && val !== old) this.fetch_decay_results_data(); },
		includeVoltageApplied(val, old) { if (val && val !== old) this.fetch_decay_results_data(); },
		include4HourValue(val, old) { if (val && val !== old) this.fetch_decay_results_data(); },
		include10HourValue(val, old) { if (val && val !== old) this.fetch_decay_results_data(); },
		include24Hourvalue(val, old) { if (val && val !== old) this.fetch_decay_results_data(); },
		includeMaxValue(val, old) { if (val && val !== old) this.fetch_decay_results_data(); },
		includeLastValue(val, old) { if (val && val !== old) this.fetch_decay_results_data(); },
		includeResidualvoltage(val, old) { if (val && val !== old) this.fetch_decay_results_data(); },
		tableRows: {
			handler(rows) {
				if ((!this.include_table || this.tableHeaders.length >= 15 || this.multipleRecordings) && rows && rows.length) {
					const recDate = this.selected_recording
						? this.formatDate(this.selected_recording.start)
						: null;
					const table_rows = rows.map(r => ({
						channelId: r.channelId,
						label: r.channelLabel,
						date: recDate,
						value: this.pickRowScaleValue(r),
						color: r.color,
					}));
					this.$emit("decay-table-image", {
						data_only: true,
						settings: this.collectDecaySettings(),
						include_table: false,
						summary_table: { table_rows }, tableHeaders: this.tableHeaders, tableRows: this.tableRows
					});
				}
			},
			flush: 'post'
		},
	},
	
	methods: {
		onDecayTableImg(dataUrl) {
			// console.log("table rows", this.tableRows)
			// console.log("table headers", this.tableHeaders)
			const recDate = this.selected_recording
				? this.formatDate(this.selected_recording.start)  // "yyyy-mm-dd"
				: null;
			const table_rows = (this.tableRows || []).map(r => ({
				channelId: r.channelId,
				label: r.channelLabel,
				date: recDate,
				value: this.pickRowScaleValue(r),
				color: r.color,
			}));
			if (this.selected_recording) {
				const payload = {
					url: dataUrl.url,
					height: dataUrl.height,
					width: dataUrl.width,
					settings: this.collectDecaySettings(), include_table: this.include_table,
					summary_table: { table_rows }, tableHeaders: this.tableHeaders, tableRows: this.tableRows
				};
				this.$emit("decay-table-image", payload);
			} else {
				const payload = {
					url: dataUrl.url,
					height: dataUrl.height,
					width: dataUrl.width,
					settings: this.collectDecaySettings(), include_table: this.include_table,
					summary_table: { table_rows }, tableHeaders: this.tableHeaders, tableRows: this.tableRows
				};
				this.$emit("decay-table-image", payload);
			}
    },
		onBarChartImg(payload) {
			this.$emit("decay-barchart-image", {
				url: payload.url,
				width: payload.width,
				height: payload.height,
				settings: this.collectDecaySettings(), include_bar_chart: this.include_bar_chart
			});
		},
		requestExports(){
			if (this.include_table) this.$refs.decayTbl?.exportImg();
			if (this.include_bar_chart) this.$refs.bar?.exportImg();
		},
		onIncludeBarChart() {
			this.$emit("include-bar-chart", this.include_bar_chart)
		},
		onIncludeDecayResultsTable() {
			this.$emit("include-table", this.include_table)
		},
    collectDecaySettings() {
      return {
        include: {
          voltageApplied: this.includeVoltageApplied,
          instantOff: this.includeInstantOff,
          h4: this.include4HourValue,
          h10: this.include10HourValue,
          h24: this.include24Hourvalue,
          maxValue: this.includeMaxValue,
          lastValue: this.includeLastValue,
					residualVoltage: this.includeResidualvoltage,
        },
      };
    },
		formatDate(dateString) {
      const d = new Date(dateString);
      const year = d.getFullYear();
      const month = ('0' + (d.getMonth() + 1)).slice(-2);
      const day = ('0' + d.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
		channelNameById(id) {
      for (const zone of [this.selected_zone]) {
        for (const node of zone.nodes) {
          for (const key in node.channels) {
            const ch = node.channels[key];
            if (ch.id === id) {
              const nodeName = node.name || `Node ${node.id}`;
              const chName = ch.name || ch.code || id;
              return `${nodeName}-${chName}`;
            }
          }
        }
      }
      return `Channel ${id}`;
    },

		channelById(id) {
			const zone = this.selected_zone;
			for (const node of zone.nodes) {
				for (const key in node.channels) {
					const ch = node.channels[key];
					if (ch.id === id) return ch;
				}
			}
			return null;
		},

		nodeByChannelId(id) {
			const zone = this.selected_zone;
			for (const node of zone.nodes) {
				for (const key in node.channels) {
					const ch = node.channels[key];
					if (ch.id === id) return node;
				}
			}
			return null;
		},

		unitForKey(key) {
			const series = this.bar_chart_data?.[key]?.series || [];
			for (const s of series) {
				const unit = this.channelById(s.channelId)?.formula?.unit;
				if (unit) return unit;
			}
			return "";
		},
		
		recording_ranges() {
			const ranges = [];
			for (const rec of this.selected_recordings || []) {
				const from = new Date(rec?.start).getTime();
				if (!Number.isFinite(from)) continue;
				const stop = rec?.stop ? new Date(rec.stop).getTime() : NaN;
				ranges.push({
					key: this.formatDate(rec.start),
					from,
					to: Number.isFinite(stop) ? stop : Infinity
				});
			}
			ranges.sort((a, b) => a.from - b.from);
			return ranges;
		},

		range_at_time(ranges, t) {
			if (!ranges.length || !isFinite(t)) return null;
			let lo = 0;
			let hi = ranges.length - 1;
			let found = -1;
			while (lo <= hi) {
				const mid = (lo + hi) >> 1;
				if (ranges[mid].from <= t) { found = mid; lo = mid + 1; }
				else hi = mid - 1;
			}
			if (found < 0) return null;
			return t <= ranges[found].to ? ranges[found] : null;
		},
		async fetch_decay_results_data() {
			// console.log("this.selected_interval", this.selected_interval)
			if (!this.selected_recording) {
				if (!Array.isArray(this.selected_recordings) ||
						!this.selected_recordings.length ||
						this.selected_recording_type !== 7) {
					this.bar_chart_data = {};
					return;
				}

				const seriesList = this.series_with_color || [];
				if (seriesList.length) {
					const results = {};
					const ranges = this.recording_ranges();
					const indexed = seriesList.map((s) => {
						const byKey = new Map();
						for (const p of s.data || []) {
							if (p.maxVal == null || !p.minDate) continue;
							const t = +p.minDate;
							if (!isFinite(t)) continue;
							const range = this.range_at_time(ranges, t);
							if (range) byKey.set(range.key, p);
						}
						return { id: s.id, byKey };
					});
					for (const range of ranges) {
						const series = [];
						for (const idx of indexed) {
							const pt = idx.byKey.get(range.key);
							if (pt) {
								const v2 = pt.minVal != null ? pt.minVal : pt.maxVal;
								series.push({ channelId: idx.id, data: [[ +pt.minDate, +pt.maxDate, v2, pt.maxVal, null, null ]] });
							}
						}
						results[range.key] = { series };
					}
					this.bar_chart_data = results;
					return;
				}

				if (this.series_with_color != null) {
					return;
				}

				const projectId = this.$app.sltd.project.id;
				const results = {};

				const getChannelIds = (rtype, extra = () => true) => {
					const ids = [];
					for (const node of this.selected_zone?.nodes || []) {
						for (const k in node.channels) {
							const ch = node.channels[k];
							if (ch.userVisible) {
								const updatedOk =
									new Date(ch.lastValueUpdated || "1900-01-01") > new Date("2020-01-01");
								if (updatedOk && this.relevantChannel(ch, rtype) && extra(ch, node)) {
									ids.push(ch.id);
								}
							}
						}
					}
					return ids;
				};

				await Promise.all(
					this.selected_recordings.map(async (rec) => {
						const start = new Date(rec?.start);
						const stop  = new Date(rec?.stop);
						if (isNaN(+start) || isNaN(+stop)) return;

						const key = this.formatDate(start);
						const recordingIdForTag =
							rec?.id && rec?.dto?.type === Camur.recording_type.rectype_decay_results ? rec.id : 0;
						const channel_ids = getChannelIds(Camur.recording_type.rectype_decay_results);
						if (!channel_ids.length) { results[key] = { series: [] }; return; }

						const filters = {
							recordingId: recordingIdForTag,
							recordingType: Camur.recording_type.rectype_decay_results
						};
						const ONE_DAY = 24 * 60 * 60 * 1000;
						const fetchStart = new Date(start.getTime() - ONE_DAY);
						const fetchStop = new Date(stop.getTime() + ONE_DAY);
						results[key] = await this.bar_chart_data_api.fetch(
							fetchStart, fetchStop, 96, projectId, null, channel_ids, filters, false, true, 1002
						);
					})
				);
				this.bar_chart_data = results;
				return;
			}
			const RESULT_TAGS = new Set([4, 10, 24, 1000, 1001, 1002, 1003, 1004]);
			const selected = this.selected_recording;

			const baseRecordingType =
				selected?.dto.type && selected.dto.type !== 0
					? selected.dto.type
					: this.selected_recording_type;			

			const value_tags = [];
			if (this.include4HourValue)  value_tags.push({ tag: "4_hour_value",  value: 3 });
			if (this.include10HourValue) value_tags.push({ tag: "10_hour_value", value: 9 });
			if (this.include24Hourvalue) value_tags.push({ tag: "24_hour_value", value: 23 });
			if (this.includeInstantOff)  value_tags.push({ tag: "instant_off_value", value: 1000 });
			// Always fetch last and max_depolarization for y-axis scaling even when not displayed
			value_tags.push({ tag: "last_depolarization", value: 1001 });
			value_tags.push({ tag: "max_depolarization", value: 1002 });
			if (this.includeVoltageApplied) value_tags.push({ tag: "voltage_applied", value: 1003});
			if (this.includeResidualvoltage) value_tags.push({ tag: "residual_voltage", value: 1001})

			const recording_start = selected
				? new Date(selected.start)
				: new Date(this.selected_recording.from_date);
			const recording_stop = selected
				? new Date(selected.stop)
				: new Date(this.selected_recording.to_date);

			const results = {};
			for (const vt of value_tags) {
				if (vt.tag == "voltage_applied" || vt.tag == "residual_voltage")
					continue;

				const isResultsTag = RESULT_TAGS.has(vt.value);

				const recordingTypeForTag = isResultsTag
					? Camur.recording_type.rectype_decay_results
					: baseRecordingType;

				const recordingIdForTag =
					selected?.id &&
					selected?.dto.type === recordingTypeForTag
						? selected.id
						: 0;

				const all_flag_for_tag =
					recordingTypeForTag === Camur.recording_type.rectype_decay_results &&
					recordingIdForTag === 0;

				let channel_ids = [];
				for  (let node of this.selected_zone.nodes) {
					for (let channelkey in node.channels) {
						let channel = node.channels[channelkey];
						if (channel.userVisible) {
							if (channel.lastValueUpdated > "2020-01-01") {
								if (this.relevantChannel(channel, recordingTypeForTag))
									channel_ids.push(channel.id);
							}  
						}
					}
				}

				if (channel_ids.length == 0) {
					continue;
				}

				const resp = await this.bar_chart_data_api.fetch(
					recording_start,
					recording_stop,
					96,
					this.$app.sltd.project.id,
					null,
					channel_ids,
					{
						recordingId: recordingIdForTag,
						recordingType: recordingTypeForTag,
					},
					false,
					true,
					vt.value
				);

				results[vt.tag] = resp;
			}
			if (this.includeVoltageApplied) {
				let channel_ids = [];
				for  (let node of this.selected_zone.nodes) {
					for (let channelkey in node.channels) {
						let channel = node.channels[channelkey];
						if (channel.userVisible) {
							if (channel.lastValueUpdated > "2020-01-01") {
								if (this.relevantChannel(channel, 3) && this.nodeByChannelId(channel.id).is_power_supply && channel.code == "U") {
									// console.log("channel", channel)
									// console.log("channel node", this.nodeByChannelId(channel.id))
										channel_ids.push(channel.id);
								}
							}  
						}
					}
				}
				if (channel_ids.length !== 0) {
					const resp = await this.bar_chart_data_api.fetch(
						recording_start,
						recording_stop,
						1,
						this.$app.sltd.project.id,
						null,
						channel_ids,
						{
							recordingType: 3,
						},
						false,
						false			
					);
	
					results["voltage_applied"] = resp;
					// console.log("restuls", resp)
				}
			}
			if (this.includeResidualvoltage) {
				let channel_ids = [];
				for  (let node of this.selected_zone.nodes) {
					for (let channelkey in node.channels) {
						let channel = node.channels[channelkey];
						if (channel.userVisible) {
							if (channel.lastValueUpdated > "2020-01-01") {
								if (this.relevantChannel(channel, 3) && this.nodeByChannelId(channel.id).is_power_supply && channel.code == "U") {
									// console.log("channel", channel)
									// console.log("channel node", this.nodeByChannelId(channel.id))
										channel_ids.push(channel.id);
								}
							}  
						}
					}
				}
				if (channel_ids.length !== 0) {
					const resp = await this.bar_chart_data_api.fetch(
						recording_start,
						recording_stop,
						1,
						this.$app.sltd.project.id,
						null,
						channel_ids,
						{
							recordingType: 3,
						},
						false,
						false,
						1001
					);
	
					results["residual_voltage"] = resp;
				}
				// console.log("restuls", resp)
			}
			this.bar_chart_data = results;
			// console.log("bar_chart_data snapshot",
			// 	JSON.parse(JSON.stringify(results))
			// );
			await this.$nextTick();
    	this.requestExports();
		},

		relevantChannel(channel, recordingType) {
			if (recordingType > 0) {
				switch (recordingType) {
					case Camur.recording_type.rectype_lpr_results:
						let node = this.project.find_node(channel.nodeId);
						if ((node.capability == Camur.node_type.ntype_corrowatch) || (node.capability == Camur.node_type.ntype_ladder)) {
							if (channel.no >= 24)
								return true;
							else
								return false;  
						} else if (node.capability == Camur.node_type.ntype_lpr) {
							if (channel.no >= 3)
								return true;
							else
								return false;  
						} else {
							return false;  
						}
					default:
						return true;
				}
			}
			else
				return true;
		},
		isOnVoltageChannel(id) {
			const node = this.nodeByChannelId(id);
			const ch = this.channelById(id);
			return !!(node?.is_power_supply && ch?.code === "U");
		},
		computeChannelOrder() {
			const order = new Map();
			if (!this.selected_zone) return order;

			const channelSort = (a, b) =>
				(a?.io ?? 99) - (b?.io ?? 99) ||
				(a?.no ?? 9999) - (b?.no ?? 9999) ||
				(a?.id ?? 0) - (b?.id ?? 0);

			const nodes = this.$util?.sort_table
				? this.$util.sort_table(this.selected_zone.nodes, "sortIndex")
				: [...(this.selected_zone.nodes || [])];

			let rank = 0;
			for (const node of nodes) {
				const perNode = Object.values(node.channels || {}).sort(channelSort);
				for (const ch of perNode) {
					const id = Number(ch?.id) || ch?.id;
					if (!order.has(id)) order.set(id, rank++);
				}
			}
			return order;
		},

		sortTableRows(rows) {
			const order = this.computeChannelOrder();
			const INF = Number.POSITIVE_INFINITY;

			return [...rows].sort((a, b) => {
				const av = this.isOnVoltageChannel(a.channelId) ? 1 : 0;
				const bv = this.isOnVoltageChannel(b.channelId) ? 1 : 0;
				if (av !== bv) return av - bv;                // on-voltage to bottom
				const ra = order.has(a.channelId) ? order.get(a.channelId) : INF;
				const rb = order.has(b.channelId) ? order.get(b.channelId) : INF;
				if (ra !== rb) return ra - rb;                // project-tree order
				return a.channelId - b.channelId;             // stable fallback
			});
		},
		pickRowScaleValue(r) {
			// Use max_depolarization when available.
			// Fall back to the highest depolarization-type value in the row so that
			// recordings without max_depolarization still scale correctly.
			if (r?.values?.max_depolarization != null) return r.values.max_depolarization;
			// max_depolarization not in values (includeMaxValue=false) — look up from fetched data
			const _maxS = this.bar_chart_data?.max_depolarization?.series?.find(x => x.channelId === r?.channelId);
			const _maxV = this.pickValForKey(_maxS, 'max_depolarization');
			if (_maxV != null) return _maxV;
			const EXCLUDE = new Set(['voltage_applied', 'residual_voltage']);
			const nums = Object.entries(r?.values || {})
				.filter(([k, v]) => !EXCLUDE.has(k) && typeof v === 'number' && isFinite(v))
				.map(([, v]) => v);
			return nums.length ? Math.max(...nums) : undefined;
		},
		pickValForKey(series, key) {
			if (!series?.data?.length) return null;
			// Server appends recording-boundary null markers ([start, stop, null, null, 0],
			// length 5) at the end of each series. Walk back to the last real bucket.
			let last = null;
			for (let i = series.data.length - 1; i >= 0; i--) {
				const pt = series.data[i];
				if (Array.isArray(pt) && pt[2] != null && pt[3] != null) {
					last = pt;
					break;
				}
			}
			if (!last) return null;

			if (key === "residual_voltage") return last[2]; // use index 2 for residual voltage
			return last[3]; // all others
		},
	},
	computed: {
		multipleRecordings() {
			return !this.selected_recording &&
						Array.isArray(this.selected_recordings) &&
						this.selected_recordings.length &&
						this.selected_recording_type === 7;
		},
		chartGroups() {
			if (!this.chartHeaders.length) return [];

			const ids = new Set();
			for (const h of this.chartHeaders) {
				const series = this.bar_chart_data[h.key]?.series || [];
				for (const s of series) {
					if (!this.nodeByChannelId(s.channelId)?.is_power_supply) {
						ids.add(s.channelId);
					}
				}
			}

			const pickVal = (series, key) => this.pickValForKey(series, key);

			const groups = Array.from(ids).map(id => {
				const values = {};
				for (const h of this.chartHeaders) {
					const s = (this.bar_chart_data[h.key]?.series || []).find(x => x.channelId === id);
					values[h.key] = pickVal(s, h.key);
				}
				let color_of_serie = "";
				if (this.series_with_color) {
					for (let serie of this.series_with_color) {
						if (serie.id == this.channelById(id)?.id) {
							color_of_serie = serie.color;
						}
					}
				}
				return { channelId: id, channelLabel: this.channelNameById(id), values, color: color_of_serie };
			});

			return this.sortTableRows(groups);
		},
		legendHeaders() {
			return this.chartHeaders.map(h => {
				const u = this.unitForKey(h.key);
				return { ...h, label: u ? `${h.label} (${u})` : h.label };
			});
		},
		chartHeaders() {
			const headers = [];

			const sel = this.selected_recording;
			const ioDelay = sel?.dto?.decay?.instantOffDelay;

			if (this.includeInstantOff) {
				const label = Number.isFinite(ioDelay)
					? `IR value (${ioDelay}s delay)`
					: "IR value";
				headers.push({ key: "instant_off_value", label });
			}
			if (this.include4HourValue)  headers.push({ key: "4_hour_value",  label: this.$txt.h4_value });
			if (this.include10HourValue) headers.push({ key: "10_hour_value", label: this.$txt.h10_value });
			if (this.includeMaxValue)    headers.push({ key: "max_depolarization",  label: this.$txt.max_value });
			if (this.includeLastValue)   headers.push({ key: "last_depolarization", label: this.$txt.last_value });
			if (this.include24Hourvalue) headers.push({ key: "24_hour_value", label: this.$txt.h24_value });

			return headers;
		},
		tableHeaders() {
			if (this.multipleRecordings) {
				const keys = Object.keys(this.bar_chart_data).sort();
				return keys.map(k => ({ key: k, label: k }));
			}
			const headers = [];
			const sel = this.selected_recording;
			const ioDelay = sel?.dto?.decay?.instantOffDelay;
			if (this.includeInstantOff) {
				const label = Number.isFinite(ioDelay) ? `${this.$txt.ir_value} (${ioDelay}s delay)` : "IR value";
				headers.push({ key: "instant_off_value", label });
			}
			if (this.includeVoltageApplied) headers.unshift({ key: "voltage_applied", label: this.$txt.on_voltage });
			if (this.include4HourValue)  headers.push({ key: "4_hour_value",  label: this.$txt.h4_value });
			if (this.include10HourValue) headers.push({ key: "10_hour_value", label: this.$txt.h10_value });
			if (this.includeMaxValue)    headers.push({ key: "max_depolarization",  label: this.$txt.max_value });
			if (this.includeLastValue)   headers.push({ key: "last_depolarization", label: this.$txt.last_value });
			if (this.include24Hourvalue) headers.push({ key: "24_hour_value", label: this.$txt.h24_value });
			if (this.includeResidualvoltage) headers.push({ key: "residual_voltage", label: this.$txt.residual_voltage });
			return headers;
		},

		tableRows() {
			if (this.multipleRecordings) {
				const keys = Object.keys(this.bar_chart_data).sort();
				if (!keys.length) return [];

				const channelIds = new Set();
				for (const k of keys) {
					const series = this.bar_chart_data[k]?.series || [];
					for (const s of series) {
						if (!this.nodeByChannelId(s.channelId)?.is_power_supply) channelIds.add(s.channelId);
						else channelIds.add(s.channelId);
					}
				}

				const pickVal = (series, key) => this.pickValForKey(series, key);

				const rows = Array.from(channelIds).sort((a,b)=>a-b).map(id => {
					const values = {};
					for (const k of keys) {
						const s = (this.bar_chart_data[k]?.series || []).find(x => x.channelId === id);
						values[k] = pickVal(s, k);
					}
					
					let color_of_serie = "";
					if (this.series_with_color) {
						for (let serie of this.series_with_color) {
							if (serie.id == this.channelById(id)?.id) {
								color_of_serie = serie.color;
							}
						}
					}
					return { channelId: id, channelLabel: this.channelNameById(id), values, color: color_of_serie };
				});

				// push on-voltage rows to the bottom
				return this.sortTableRows(rows);
			}

			// single-recording
			if (!this.tableHeaders.length) return [];

			const channelIds = new Set();
			for (const h of this.tableHeaders) {
				const series = this.bar_chart_data[h.key]?.series || [];
				for (const s of series) channelIds.add(s.channelId);
			}

			const pickVal = (series, key) => this.pickValForKey(series, key);

			const rows = Array.from(channelIds).sort((a,b)=>a-b).map(id => {
				const values = {};
					for (const h of this.tableHeaders) {
						const s = (this.bar_chart_data[h.key]?.series || []).find(x => x.channelId === id);
						values[h.key] = pickVal(s, h.key);
					}
					if (values['last_depolarization'] == null) {
						const s = (this.bar_chart_data['last_depolarization']?.series || []).find(x => x.channelId === id);
						if (s) values['last_depolarization'] = pickVal(s, 'last_depolarization');
					}
					if (this.includeMaxValue && values['max_depolarization'] == null) {
						const DEPOL_KEYS = ['4_hour_value', '10_hour_value', '24_hour_value', 'last_depolarization'];
						const nums = DEPOL_KEYS
							.map(k => pickVal((this.bar_chart_data[k]?.series || []).find(x => x.channelId === id), k))
							.filter(v => typeof v === 'number' && isFinite(v));
						if (nums.length) values['max_depolarization'] = Math.max(...nums);
					}
					let color_of_serie = "";
				if (this.series_with_color) {
					for (let serie of this.series_with_color) {
						if (serie.id == this.channelById(id)?.id) {
							color_of_serie = serie.color;
						}
					}
				}
				return { channelId: id, channelLabel: this.channelNameById(id), values, color: color_of_serie };
			});

			// push on-voltage rows to the bottom
			return this.sortTableRows(rows);
		},
	},
};
</script>
<style>
.checkbox-label {
	font-size: 14px;
	color: #333;
}
</style>